import {
    EDIT_ROLEPERMISSION,
    ALL_ROLEPERMISSION,
    GET_ROLEPERMISSION
  } from "./actionTypes"
  
  const initialState = {
    error: "",
    loading: false,
    data: null
  }
  
  const rolePermission = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_ROLEPERMISSION:
            state = {
              ...state,
              data:action.payload.data,
              loading: false,
            }
            break
            case GET_ROLEPERMISSION:
              state = {
                ...state,
                loading: true,
              }
              break
            case ALL_ROLEPERMISSION:
              state = {
                ...state,
                data:action.payload.data,
                loading: false
              }
              break
        default:
        break
    }
    return state
  }

  export default rolePermission
  